import React from 'react'
import Icon from 'components/ui/icon'
import styles from './index.module.css'

const NotificationBell = ({ badge, onClick }) => (
  <button className={styles.notificationBell} type="button" onClick={onClick}>
    <Icon type="notification" width="24" height="24" />
    {badge ? <div className={styles.notificationBellBadge} /> : null}
  </button>
)

export default NotificationBell
